// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4701) return "static/chunks/4701-1020ba124996da5c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "68045cecb5b1bb3d" + ".js";
};